import React, { FunctionComponent } from 'react';
import AddDashboardUser from '../../components/AddDashboardUser';

/**
 * ComponentsPage props
 */
interface Props {}

/**
 * ComponentsPage Component
 */
const ComponentsPage: FunctionComponent<Props> = () => (
  <div className="p-3">
    <AddDashboardUser />
  </div>
);

export default ComponentsPage;
